import { ExpandOutlined } from '@mui/icons-material';
import React,{useState} from 'react'
import { countClosed, countInProgress, countOnHold, countOpen, countReopened, countSelfCanceled, countTotal } from '../statusReportServices';
import GrievanceListDialog from './GrievanceListDialog';

function StatusCounterByGroup({reportData,assignedGrievanceType,supervisorName,masters,getMasterLabel}) {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [grievanceList,setGrievanceList] = useState(null);
    const [expend,setExpend] = useState(false);

    const handleCountClick = ( func, type) =>{
        let data = func(reportData,type);
        setGrievanceList(data);
        setDialogStatus(true);
    }

    return (
        <div className='card p-3 mb-3 shadow'>
            <div className='row'>
                <div className='col-md-2 d-flex justify-content-between align-items-center'>
                    <h5 type="button" className='text-primary' onClick={()=>setExpend(!expend)}>{supervisorName}</h5>
                    <button className='btn btn-primary' onClick={()=>setExpend(!expend)} > <ExpandOutlined/>  </button>
                </div>

                <div className='col-md-8'>
                    <div className='row'>
                        <div className="col-md-2 ">
                            <div className="card bg-primary text-white shadow p-1">
                                <div>Open</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(countOpen)}>
                                        {countOpen(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-danger text-white shadow p-1">
                                <div>Reopened</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(countReopened)}>
                                        {countReopened(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-warning shadow p-1">
                                <div>In Progress</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(countInProgress)}>
                                        {countInProgress(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-success text-white shadow p-1">
                                <div>Closed</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(countClosed)}>
                                        {countClosed(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-info shadow p-1">
                                <div>Self Canceled</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(countSelfCanceled)}>
                                        {countSelfCanceled(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2 ">
                            <div className="card bg-light shadow p-1">
                                <div>On Hold</div>
                                <span className="text-center">
                                    <h1 type="button" onClick={()=>handleCountClick(countOnHold)}>
                                        {countOnHold(reportData).length}
                                    </h1>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-2 ">
                    <div className="card bg-dark text-white shadow p-1">
                        <div>Total</div>
                        <span className="text-center">
                            <h1 type="button" onClick={()=>handleCountClick(countTotal)}>
                                {countTotal(reportData).length}
                            </h1>
                        </span>
                    </div>
                </div>
            </div>
            {expend &&
            <div className='row mt-2'>
                <div className='col-md-2'></div>
                <div className='col-md-10'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Grievance Type</th>
                                <th className='bg-primary text-white' >Open</th>
                                <th className='bg-danger text-white' >ReOpened</th>
                                <th className='bg-warning' >In Progress</th>
                                <th className='bg-success text-white' >Closed</th>
                                <th className='bg-info' >Self Canceled</th>
                                <th className='bg-ligh' >On Hold</th>
                                <th className='bg-dark text-white' >On Hold</th>
                            </tr>
                        </thead>
                        <tbody>
                            {assignedGrievanceType.map( grievanceType=>
                                <tr>
                                <th>{getMasterLabel('grievance-type',  grievanceType)}  </th>
                                    <td className='bg-primary text-white'>
                                        <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(countOpen,grievanceType)}>
                                            {countOpen(reportData,grievanceType).length}
                                        </button>
                                    </td>
                                    <td className='bg-danger text-white'>
                                        <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(countReopened,grievanceType)}>
                                            {countReopened(reportData,grievanceType).length}
                                        </button>
                                    </td>
                                    <td className='bg-warning'>
                                        <button className='btn btn-link' type='button' onClick={()=>handleCountClick(countInProgress,grievanceType)}>
                                            {countInProgress(reportData,grievanceType).length}
                                        </button>
                                    </td>
                                    <td className='bg-success text-white'>
                                        <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(countClosed,grievanceType)}>
                                            {countClosed(reportData,grievanceType).length}
                                        </button>
                                    </td>
                                    <td className='bg-info'>
                                        <button className='btn btn-link ' type='button' onClick={()=>handleCountClick(countSelfCanceled,grievanceType)}>
                                            {countSelfCanceled(reportData,grievanceType).length}
                                        </button>
                                    </td>
                                    <td className='bg-light'>
                                        <button className='btn btn-link' type='button' onClick={()=>handleCountClick(countOnHold,grievanceType)}>
                                            {countOnHold(reportData,grievanceType).length}
                                        </button>
                                    </td>
                                    <td className='bg-dark text-white'>
                                        <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(countTotal,grievanceType)}>
                                            {countTotal(reportData,grievanceType).length}
                                        </button>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>
            </div>
            }
            <GrievanceListDialog grievanceList={grievanceList} dialogStatus={dialogStatus} setDialogStatus={setDialogStatus} getMasterLabel={getMasterLabel} />
        </div>
    )
}

export default StatusCounterByGroup